export default "__VITE_ASSET__D_cFray7__"